import PropTypes from 'prop-types';

import SideMsg from '#/modules/commonComponents/SideMsg';
import { costEstimateSideMsgDetailBlock } from '#/modules/crmMgmt/costEstimate/data/costEstimateSideMsgConfig';

const BLOCKS = [costEstimateSideMsgDetailBlock];

const CostEstimateSideMsg = ({ displayData }) => (
  <SideMsg
    title="成本試算"
    titleValue="name"
    displayData={displayData}
    blocks={BLOCKS}
  />
);

CostEstimateSideMsg.propTypes = {
  displayData: PropTypes.object,
};

export default CostEstimateSideMsg;
